import styled from 'styled-components';

export const AdLayoutSensor = styled.div`
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  align-self: flex-start;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
`;
